import { authentication } from '@/plugins/firebase'
import { useLoginStore } from '@/store/app'
import {
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithCustomToken,
  GoogleAuthProvider,
  OAuthProvider
} from 'firebase/auth'

const signUpWithEmail = async (emailAux: string, passwordAux: string) => {
  try {
    const credential = await createUserWithEmailAndPassword(authentication, emailAux, passwordAux)
    if (credential == null || credential == undefined) throw new Error('Credential not exists')
    const token = await getToken()
    if (token == null || token == undefined) throw new Error('Token not exists')
    const user = credential.user
    const email = user.email
    const uid = user.uid
    // const name = user.displayName
    if (email == null || email == undefined) throw new Error('Email not exists')
    console.log('Signed up with Email and Password successfully')
    return { token, email, firebaseUid: uid }
  } catch (error: any) {
    // const errorCode = error.code
    const errorMessage = error.message
    const email = error.customData != null ? error.customData.email : ''
    console.info(`Error signing up with Email and Password for email ${email}: ${errorMessage}`)
    throw error
  }
}

const signInWithEmail = async (emailAux: string, passwordAux: string) => {
  try {
    const credential = await signInWithEmailAndPassword(authentication, emailAux, passwordAux)
    if (credential == null || credential == undefined) throw new Error('Credential not exists')
    const token = await getToken()
    if (token == null || token == undefined) throw new Error('Token not exists')
    const user = credential.user
    const email = user.email
    const uid = user.uid
    const refreshToken = user.refreshToken
    // const name = user.displayName
    if (email == null || email == undefined) throw new Error('Email not exists')
    console.log('Signed in with Email and Password successfully')
    return { token, email, firebaseUid: uid, refreshToken }
  } catch (error: any) {
    // const errorCode = error.code
    const errorMessage = error.message
    const email = error.customData != null ? error.customData.email : ''
    console.info(`Error signing in with Email and Password for email ${email}: ${errorMessage}`)
    throw error
  }
}

const signInWithGoogle = async () => {
  const provider = new GoogleAuthProvider()
  try {
    const result = await signInWithPopup(authentication, provider)
    const credential = GoogleAuthProvider.credentialFromResult(result)
    if (credential == null || credential == undefined) throw new Error('Credential not exists')
    // const googleAccessToken = credential.accessToken
    // const token = credential.idToken
    const token = await getToken()
    if (token == null || token == undefined) throw new Error('Token not exists')
    const user = result.user
    const email = user.email
    const uid = user.uid
    // const name = user.displayName
    if (email == null || email == undefined) throw new Error('Email not exists')
    console.log('Signed in with Google successfully')
    return { token, email, firebaseUid: uid }
  } catch (error: any) {
    // const errorCode = error.code
    const errorMessage = error.message
    const email = error.customData != null ? error.customData.email : ''
    // const credential = GoogleAuthProvider.credentialFromError(error)
    console.info(`Error signing in with Google for email ${email}: ${errorMessage}`)
    throw error
  }
}

const signInWithApple = async () => {
  const provider = new OAuthProvider('apple.com')
  try {
    const result = await signInWithPopup(authentication, provider)
    const credential = OAuthProvider.credentialFromResult(result)
    if (credential == null || credential == undefined) throw new Error('Credential not exists')
    // const appleAccessToken = credential.accessToken
    // const token = credential.idToken
    const token = await getToken()
    if (token == null || token == undefined) throw new Error('Token not exists')
    const user = result.user
    const email = user.email
    const uid = user.uid
    // const name = user.displayName
    if (email == null || email == undefined) throw new Error('Email not exists')
    console.log('Signed in with Apple successfully')
    return { token, email, firebaseUid: uid }
  } catch (error: any) {
    // const errorCode = error.code
    const errorMessage = error.message
    const email = error.customData != null ? error.customData.email : ''
    // const credential = OAuthProvider.credentialFromError(error)
    console.info(`Error signing in with Apple for email ${email}: ${errorMessage}`)
    throw error
  }
}

const signInWithCustomTokenInternal = async (customToken: string) => {
  try {
    const credential = await signInWithCustomToken(authentication, customToken)
    if (credential == null || credential == undefined) throw new Error('Credential not exists')
    const token = await getToken()
    if (token == null || token == undefined) throw new Error('Token not exists')
    const user = credential.user
    const email = user.email
    const uid = user.uid
    // const name = user.displayName
    if (email == null || email == undefined) throw new Error('Email not exists')
    console.log('Signed in with Custom Token successfully')
    return { token, email, firebaseUid: uid }
  } catch (error: any) {
    // const errorCode = error.code
    const errorMessage = error.message
    const email = error.customData != null ? error.customData.email : ''
    console.info(`Error signing in with Custom Token for email ${email}: ${errorMessage}`)
    throw error
  }
}

const getToken = async (forceRefresh: boolean = false) => {
  const loginStore = useLoginStore()
  try {
    const firebaseUser = authentication.currentUser
    if (!firebaseUser) throw new Error('FirebaseUser not exists')
    const token = await firebaseUser.getIdToken(forceRefresh)
    const refreshToken = firebaseUser.refreshToken
    loginStore.setRefreshToken(refreshToken)
    return token
  } catch (error: any) {
    // const errorCode = error.code
    const errorMessage = error.message
    console.info(`Error refreshing token: ${errorMessage}`)
    throw error
  }
}

export {
  signInWithGoogle,
  signInWithApple,
  signUpWithEmail,
  signInWithEmail,
  signInWithCustomTokenInternal,
  getToken
}
